import type { Snippet } from '../types/snippet.ts';
import { SnippetScope } from '@confluence/fabric-media-support/entry-points/snippetScope.ts';

export const formatInsertCount = (count: number): string => {
	if (count >= 1_000_000) {
		const millions = count / 1_000_000;
		const isWholeNumber = millions % 1 === 0;
		const usageValue = isWholeNumber ? millions.toFixed(0) : millions.toFixed(1);
		return `${usageValue}M`;
	}
	if (count >= 1000) {
		const thousands = count / 1000;
		const isWholeNumber = thousands % 1 === 0;
		const usageValue = isWholeNumber ? thousands.toFixed(0) : thousands.toFixed(1);
		return `${usageValue}K`;
	}
	return String(count);
};

export const shouldShowInsertCount = (snippet: Snippet): boolean =>
	(snippet.scope === SnippetScope.SITE || snippet.scope === SnippetScope.GLOBAL) &&
	snippet.insertCount !== undefined;

export const shouldShowPrivateLabel = (snippet: Snippet): boolean =>
	snippet.scope === SnippetScope.USER && !snippet.isShared;
